<template>
	<div class="scrollable only-y">		
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-basket widget-icon accent-text fs-30"></i> {{ $t('menu.prefix') }}</h2>
		</div>
		<el-dialog title="Add Country" :visible.sync="dialogFormVisible">
			<el-form ref="form" :model="country" label-width="120px">
				<el-form-item label="Countries" :label-width="formLabelWidth">
                    <template>
                        <el-select style="width: 70%;" v-model="country.countryName" @change="handleChangeSelectedCountry" filterable placeholder="Select Country">
                            <el-option
                            v-for="(item) in countries" :key="item.countryCode"
                            :label="item.countryNameEn"
                            :value="item.countryNameEn">
                            <div>
                                <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                            </div>
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                     <el-table
                        ref="multipleTable"
                        :data="tableData"
                        style="width: 100%; margin-bottom: 20px;"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        label="Code Prefix"
                        width="120">
                        <template slot-scope="scope">{{ '+'+scope.row.countryCallingCode }}</template>
                        </el-table-column>
                        <el-table-column
                        property="countryNameEn"
                        label="Country Name"
                        show-overflow-tooltip>
                        </el-table-column>
                    </el-table>
				<el-form-item v-if="tableData.length > 0 && tableData[0].countryCallingCode == '62'" label="Price CBP :">
                    <el-input style="width: 50%;" @keypress.native="numberOnly" @paste.native="paste($event, index, 'price')" v-model="country.cbp" placeholder="Nominal Price"></el-input>
                </el-form-item>
				<el-form-item label="Price BI :">
                    <el-input style="width: 50%;" @keypress.native="numberOnly" @paste.native="paste($event, index, 'price')" v-model="country.bi" placeholder="Nominal Price"></el-input>
                </el-form-item>
				<el-form-item label="Price UI :">
                    <el-input style="width: 50%;" @keypress.native="numberOnly" @paste.native="paste($event, index, 'price')" v-model="country.ui" placeholder="Nominal Price"></el-input>
                </el-form-item>
				<el-form-item label="Status :">
                    <el-switch
					class="mt-8"
                    style="display: block"
                    v-model="country.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Active"
                    inactive-text="Inactive">
                    </el-switch>
                    <!-- <div v-if="send_status" style="margin-top: 20px;">
                        <el-form >
                        <el-form-item label="Send Status Url">
                            <div>
                                <el-input :style="{ width: '68%'}" style="margin-bottom: 5px;" v-model="selectedUrlAllowStatus" placeholder="Insert Credentials URL Status"></el-input>
                            </div>
                        </el-form-item>
                            <el-form-item label="Status Type">
                                <el-checkbox-group v-model="allowed_status">
                                    <el-checkbox class="checkbox-label" label="Interactive" name="type"></el-checkbox>
                                    <el-checkbox class="checkbox-label" label="HSM" name="type"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </div> -->
                    
                </el-form-item>
                <el-form-item>
                    <el-button @click="toggleSelection()">Reset</el-button>
                </el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addPrefix" :loading="loadingBtn">Submit</el-button>
    		<el-button @click="dialogFormVisible=false">Cancel</el-button>
            </span>
		</el-dialog>
		<el-dialog title="Edit Prefix" :visible.sync="dialogFormVisible2">
			<el-form ref="form" :model="country" label-width="120px">
                     <el-table
                        :data="tableData"
						default-expand-all
                        style="width: 100%; margin-bottom: 20px;">
                        <el-table-column
                        label="Code Prefix"
                        width="120">
                        <template slot-scope="scope">{{ '+'+scope.row.countryCallingCode }}</template>
                        </el-table-column>
                        <el-table-column
                        property="countryNameEn"
                        label="Country Name"
                        show-overflow-tooltip>
                        </el-table-column>
                    </el-table>
				<el-form-item v-if="tableData.length > 0 && tableData[0].countryCallingCode == '62'" label="Price CBP :">
                    <el-input style="width: 50%;" @keypress.native="numberOnly" @paste.native="paste($event, index, 'cbp')" v-model="country.cbp" placeholder="Nominal Price"></el-input>
                </el-form-item>
				<el-form-item label="Price BI :">
                    <el-input style="width: 50%;" @keypress.native="numberOnly" @paste.native="paste($event, index, 'bi')" v-model="country.bi" placeholder="Nominal Price"></el-input>
                </el-form-item>
				<el-form-item label="Price UI :">
                    <el-input style="width: 50%;" @keypress.native="numberOnly" @paste.native="paste($event, index, 'ui')" v-model="country.ui" placeholder="Nominal Price"></el-input>
                </el-form-item>
				<el-form-item label="Status :">
                    <el-switch
					class="mt-8"
                    style="display: block"
                    v-model="country.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Active"
                    inactive-text="Inactive">
                    </el-switch>
                    <!-- <div v-if="send_status" style="margin-top: 20px;">
                        <el-form >
                        <el-form-item label="Send Status Url">
                            <div>
                                <el-input :style="{ width: '68%'}" style="margin-bottom: 5px;" v-model="selectedUrlAllowStatus" placeholder="Insert Credentials URL Status"></el-input>
                            </div>
                        </el-form-item>
                            <el-form-item label="Status Type">
                                <el-checkbox-group v-model="allowed_status">
                                    <el-checkbox class="checkbox-label" label="Interactive" name="type"></el-checkbox>
                                    <el-checkbox class="checkbox-label" label="HSM" name="type"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </div> -->
                    
                </el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="updatePrefix" :loading="loadingBtn">Submit</el-button>
    		<el-button @click="dialogFormVisible2=false">Cancel</el-button>
            </span>
		</el-dialog>
		<el-card>
			<div slot="header" class="clearfix mb-10">
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
						Total Prefix : <br>
						<span style="font-size:32px;">{{ (total) }}</span>
						<!-- <span style="font-size:32px;" v-else><i class="mdi mdi-message-text-outline fl-l"></i> -</span> -->
					</el-card>
				</el-col>
				<!-- <strong style="font-size:24px;">Total : {{total}}</strong> -->
				<el-button type="primary" @click="addNewPrefix" style="float:left;" class="mt-20 mb-20">+ Add Prefix</el-button>
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
				<el-pagination
					background
					prev-text="Prev"
					next-text="Next"
					layout="prev, pager, next"
					:page-size="10"
					@current-change="paginateProduct"
					:current-page="currentPage"
					:total="parseInt(total)">
				</el-pagination>
				</el-col>

			</div>
			
			
			<template>
				
				<el-table :data="prefix" row-key="id" style="width: 100%" v-loading="loadingProduct" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
					<!-- <el-table-column prop="children" type="expand">
						<template slot-scope="props">
							<p v-for="(item,i) in props.row.children" :key="i" style="font-weight:bold;">{{ item.countryName }}</p>
						</template>
					</el-table-column> -->
					<el-table-column
					type="index"
					width="50"
					fixed="left">
					</el-table-column>
					<el-table-column prop="type" label="Code Prefix" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ '+' + props.row.prefixCode }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="countryName" label="Country Name" width="200">
						<template slot-scope="props">
							<el-collapse v-if="props.row.children" v-model="activeNames" @change="handleChange">
								<el-collapse-item :title="props.row.countryName" name="1">
									<p v-for="(item,i) in props.row.children" :key="i" style="font-weight:bold;">{{ item.countryName }}</p>
								</el-collapse-item>
							</el-collapse>
							<p v-else style="font-weight:bold;">{{ props.row.countryName }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="price_cbp" label="Price CBP" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatPrice(props.row.price_cbp) }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="price_bi" label="Price BI" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatPrice(props.row.price_bi) }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="price_ui" label="Price UI" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatPrice(props.row.price_ui) }}</p>
						</template>
					</el-table-column>

					<el-table-column fixed="right" prop="status" label="Status" width="100">
						<template slot-scope="props">
							<el-tag v-if="props.row.status == 'true'" type="success">Active</el-tag>
							<el-tag v-else type="info">Inactive</el-tag>
							<!-- <p style="font-weight:bold;">{{ props.row.status }}</p> -->
						</template>
					</el-table-column>
					
					<el-table-column fixed="right" label="Action" width="180">
						<template slot-scope="scope">
							<el-button @click="detailProduct(scope.row)" type="primary" size="small">
								Edit
							</el-button>
							<el-button class="ml-10" type="info" @click="detailSync(scope.row)" :disabled="loadingSync" size="small">
                            	<i class="mdi mdi-sync"></i> Sync
                        	</el-button>
						</template>
					</el-table-column>
					<!-- <el-table-column fixed="right" width="100">
						<template slot-scope="scope">
							
						</template>
					</el-table-column> -->
					
				</el-table>
			</template>
		</el-card>
		<el-card class="mt-10">
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateProduct"
				:current-page="currentPage"
				:total="parseInt(total)">
			</el-pagination>
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import CountryFlag from 'vue-country-flag'
// import moment from 'moment-timezone'
const moment = require('moment')
const countryCodes = require('country-codes-list')

export default {
	name: 'Prefix',
	data () {
		return {
			activeNames: [],
            tableData: [],
            multipleSelection: [],
			value: '',
			dialogTableVisible: false,
			dialogFormVisible: false,
			dialogFormVisible2: false,
			dialogFormVisibleUpdate: false,
			dialogFormVisibleDelete: false,
			countries: [],
            country: {
				cbp:0,
				bi:0,
				ui:0,
				status:false,
				countryName: ""
			},
            selectedCountryObject:{},
			prefix:[],
            product:[],
			products: {
				allowedUser: "-",
				productName: "",
				productSKU: "",
				description: "",
				createdAt: "",
				updatedAt: "",
				type: "",
				plan: "Monthly",
				price: "",
				minPrice: "",
				tax: "",
				count: "",
				aliasName: "",
				tier: [],
				whitelistHsm: [],
				monthly_free_count: 0
			},
			total:'',
			currentPage: 1,
			loadingProduct:true,
			loadingSync: false,
			formLabelWidth: '200px',
			loadingBtn:false,
			loadingBtnDelete:false,
		}
	},
    components: {
        CountryFlag
    },
	methods: {
		synchronize(){
            this.$swal({
              title: 'Are you sure to sync prices for this prefix?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                this.loadingSync = true
                api({
                    url: config.baseApi+"prefix/sync-prefix/"+this.country._id,
                    method: "get"
                }).then(response => {
					if(response.data.ec != 200){
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
					} else {
						this.$swal(this.$t('success'), this.$t('success'), "success")
						// console.log("res",res.data)
						this.clear()
						this.Product(this.currentPage)
					}
                    this.loadingSync = false
                }).catch(error => {
                    // alert("error")
                    this.$swal(this.$t('error'), 'Sorry, sync prefix failed. Please try again later.', "error")
                    console.log("sync process error with response ",error)
                    this.loadingSync = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
                // this.additionalServiceLoadingButton = false
            });
        },
		handleChange(){
			console.log();
		},
		addNewPrefix(){
			this.clear()
			this.dialogFormVisible = true
		},
        handleChangeSelectedCountry(val){
            this.tableData = _.filter(this.countries, (v) => {
                return v.countryNameEn == val
            })
        },
        toggleSelection(rows) {
            if (rows) {
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
            } else {
            	this.$refs.multipleTable.clearSelection();
				this.multipleSelection = []
				this.country.cbp = 0
				this.country.bi = 0
				this.country.ui = 0
				this.country.status = false
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, index, field) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

            this.country[field] = FilteredChars
        },
		handleChangeProductType(value){
			// console.log(value)
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatCurr() {
	        this.products.price = this.currencyFormat(this.products.price)
	      },
		handleClick() {
			// console.log('click');
		},
		onSubmit() {
			// console.log('click');
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		formatPrice(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") value = 0
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		async Product(page = 1){
			this.loadingProduct = true
            await api({
                url: config.baseApi + "prefix?page="+page,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					// this.prefix = res.data.data.prefix
					this.total = res.data.data.total
					let childs = []
					this.prefix = res.data.data.prefix
					this.prefix.forEach(el => {
						childs = this.countries.filter( v => v.countryCallingCode == el.prefixCode && v.countryNameEn != el.countryName)
						if (childs.length > 1) {
							el.children = childs.map(val => { 
								return {
									countryCode: el.countryCode,
									countryName: val.countryNameEn,
									createdAt: el.createdAt,
									prefixCode: el.prefixCode,
									price_bi: el.price_bi,
									price_cbp: el.price_cbp,
									price_ui: el.price_ui,
									status: el.status,
									updatedAt: el.updatedAt,
									_id: el._id
								}
							})
						}
					})

					console.log(this.prefix);
				}
            })
            .catch(err => {

            })
            this.loadingProduct = false
		},
		async addPrefix(){
			this.loadingBtn = true

			if (this.multipleSelection.length == 0 || !this.country.countryName || this.country.cbp.toString() == '' && this.multipleSelection[0].countryCallingCode == '62' || this.country.bi.toString() == '' || this.country.ui.toString() == '') {
				this.$message({
					type: 'warning',
					message: 'All field is required'
				});
				this.loadingBtn = false
				return
			}

			let data = {
					"countryName": this.country.countryName,
					"countryCode": this.multipleSelection[0].countryCode,
					"prefixCode": this.multipleSelection[0].countryCallingCode,
					"price_cbp": this.country.cbp || 0,
					"price_bi": this.country.bi || 0,
					"price_ui": this.country.ui || 0,
					"status": this.country.status || 'false'
			}
			// var [] = this.products
			// if(_.isEmpty([])){
			// 	this.$message.error({
			// 		showClose: false,
			// 		message: 'All field is required'
			// 	});
			// 	return
			// }
			await api({
				url: config.baseApi + "prefix",
				method: 'post',
				data: data
			}).then(res => {
				if(res.data.ec != 200){
					if(res.data.message == "prefix_used"){
						this.$swal(this.$t('warning'), 'This prefix has been used, try again with another prefix.', "warning")
					} else{
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
					}
					// console.log('fatal error')
				} else {
					this.$message({
						type: 'success',
						message: 'Add Prefix Success'
					});
					this.clear()
					// this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// console.log("res",res.data)
					this.dialogFormVisible = false
					this.Product()
				}
			}).catch(err => {
				console.log("Error",err)
			})
			this.loadingBtn = false
		},

		async paginateProduct(page){
			this.currentPage = page
			await this.Product(this.currentPage)
		},

		async detailSync(param){
			let detail = param
			this.country._id = detail._id
			await this.synchronize()
		},

		async detailProduct(param){
			let detail = param
			this.country._id = detail._id
			this.country.countryCode = detail.countryCode
			this.country.prefixCode = detail.prefixCode
			this.country.countryName = detail.countryName
			this.country.cbp = detail.price_cbp
			this.country.bi = detail.price_bi
			this.country.ui = detail.price_ui
			this.country.status = detail.status == 'true' ? true: false
			await this.handleChangeSelectedCountry(detail.countryName)
			this.dialogFormVisible2 = true
			// console.log(param);
		},

		async updatePrefix(){
            this.loadingBtn = true

			if (!this.country._id) {
				this.loadingBtn = false
				return
			}

			if (!this.country.countryName || this.country.cbp.toString() == '' && this.country.countryCode == '62' || this.country.bi.toString() == '' || this.country.ui.toString() == '') {
				this.$message({
					type: 'warning',
					message: 'All field is required'
				});
				this.loadingBtn = false
				return
			}

			let data = {
					"countryName": this.country.countryName,
					"countryCode": this.country.countryCode,
					"prefixCode": this.country.prefixCode,
					"price_cbp": this.country.prefixCode == '62' ? this.country.cbp : 0,
					"price_bi": this.country.bi,
					"price_ui": this.country.ui,
					"status": this.country.status
			}
			await api({
				url: config.baseApi + 'prefix/' + this.country._id,
				method: 'patch',
				data: data
			}).then(res => {
				if(res.data.ec != 200){
                    // console.log('Update sukses')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					// console.log('fatal error')
					this.dialogFormVisible2 = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success")
					// console.log("res",res.data)
					this.dialogFormVisible2 = false
					this.clear()
					this.Product(this.currentPage)
				}
			}).catch(err => {
				console.log("Error",err)
            })
            this.loadingBtn=false
		},
		
		async deleteProduct(productId){
			this.loadingProduct = true
			this.loadingBtnDelete = true
			this.$confirm('This will permanently delete the product. Continue?', 'Warning', {
			confirmButtonText: 'OK',
			cancelButtonText: 'Cancel',
			type: 'warning',
			center: true
			}).then(() => {
				this.loadingBtnDelete = true
				api({
					url: config.baseApi + 'product/delete/' + productId,
					method: 'get',
					params:{
						productId:this.productId
					}
				}).then(res => {
					if(res.data.ec != 200){
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
						this.dialogFormVisible = false
					} else {
						// 
						this.$message({
							type: 'success',
							message: 'Delete completed'
						});
						this.clear()
						this.dialogFormVisible = false
						this.Product()
					}
				}).catch(err => {
					// console.log("Error",err)
				})
				this.loadingBtnDelete = false
			}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Delete canceled'
				});
			});
			
			this.loadingBtnDelete = false
			this.loadingProduct = false
		},

		clear(){
			 this.country = {
				cbp:0,
				bi:0,
				ui:0,
				status:false,
				countryName: ""
			}
			this.tableData = []
			this.multipleSelection = []
		}
	},
	async mounted(){
		await this.Product()
		// await this.getAllHSM()
	},
    created(){
        this.countries = countryCodes.all()
    }
}
</script>
<style>
.swal2-container {
  	z-index: 10000;
}

.el-collapse-item__header {
	background-color: transparent;
	border: none;
	font-weight: bold;
	color: inherit;
}

.el-collapse-item__wrap{
	background-color: transparent;
}
.el-collapse-item__content{
	color: inherit;
}

.el-collapse {
	border: none;
}

</style>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>